import React from "react";
import {
  BANNER_ITEM_HEIGHT,
  BannerEditorCardProps,
  MAX_BANNER_WIDTH,
} from "./BannerEditor.types";
import { Flex, HStack, Image, Text } from "@chakra-ui/react";
import Card from "../../dashboard/Card/Card";
import { VeriHeading } from "../../common";
import pluralize from "pluralize";

export const BannerEditoCard: React.FC<BannerEditorCardProps> = ({
  imageCount,
  ...rest
}) => {
  return (
    <Card _hover={{ cursor: "pointer" }} w={"100%"} {...rest}>
      <HStack spacing={0.5} w={"100%"} mb={10}>
        {new Array(imageCount).fill(null).map((_, index) => (
          <Flex
            alignItems={"center"}
            justifyContent={"center"}
            bg={"#EFEEFC"}
            key={index}
            w={`${100 / imageCount}%`}
            borderRadius={6}
            h={"150px"}
            px={2}
          >
            <Image
              src={`/images/banner-placeholders/${index + 1}.svg`}
              fallbackSrc={"/images/banner-placeholders/1.svg"}
            />
          </Flex>
        ))}
      </HStack>

      <VeriHeading w={"100%"} textAlign={"center"} textStyle={"h3"}>
        {`${imageCount} ${pluralize("image", imageCount)}`}
      </VeriHeading>
      <Text mt={5} textStyle={"bodyRegular"} w={"100%"} textAlign={"center"}>
        Minimum size per image: <br /> {MAX_BANNER_WIDTH / imageCount} x{" "}
        {BANNER_ITEM_HEIGHT} pixels
      </Text>
    </Card>
  );
};
